<section class="section">
    <h2 class="title">Switchboard Overview</h2>
</section>

<app-loadingbar *ngIf="!switchboard_objects"></app-loadingbar>
<div id="my_canvas"></div>
